//slider
import noUiSlider from './utils/nouislider';

//lazy load
import LazyLoad from 'vanilla-lazyload';

function catReplace() {
	$('.tax__item').hide();
	$('.data-cat span').each(function() {
		var item = $(this);
		var catName = item.data('cat');
		var catCount = item.data('num');
		$(`[data-cat='${catName}']`).show();
		$(`[data-cat='${catName}'] span.tax__count`).html(catCount);
	});

	$('.tax__item').each(function() {
		var count = parseInt(
			$(this)
				.find('.tax__count')
				.text()
		);
		if (count === 0) {
			$(this).addClass('hidden');
		} else {
			$(this).removeClass('hidden');
		}
	});
}

catReplace();

jQuery(document).ready(function($) {
	//catReplace();
	// scroll to top quand click pagination
	$('.filter__right').on('click', '.pagination', function() {
		$('html, body').animate(
			{
				scrollTop: $('.content__title').offset().top
			},
			500
		);
	});
	// Array de params pour l'ajax
	const params = {
		action: 'filter',
		prix: '',
		post_type: $('.content__title').data('type')
	};

	// Range de prix
	var rangePrix = document.getElementById('slider');
	if (rangePrix) {
		noUiSlider.create(rangePrix, {
			start: [0, 0],
			connect: true,
			step: 1,
			orientation: 'horizontal',
			range: {
				min: 0,
				max: 400
			},
			format: wNumb({
				decimals: 0
			})
		});
		// print values du range de prix
		var stepSliderValueElement = document.getElementById('values');
		rangePrix.noUiSlider.on('update', function(values) {
			if (values[0] == 0 && values[1] == 0) {
				stepSliderValueElement.innerHTML = 'Tous les prix';
			} else {
				stepSliderValueElement.innerHTML =
					'<span>' +
					values[0] +
					'</span> €' +
					' - <span>' +
					values[1] +
					'</span> €';
			}

			//push values a l'array params pour l'ajax
			params['prix'] = values;
		});

		// lancer l'ajax quand on change le range de prix
		rangePrix.noUiSlider.on('change', function() {
			ajax(params);
		});
	}

	$('.tax').on('click', '.tax__item', function() {
		// changer la categorie a active
		$(this).toggleClass('active');

		// set action de l'ajax a filter (voir ajax.php)
		params.action = 'filter';

		// effacer la valeur page pour la pagination
		if (params.hasOwnProperty('next_page')) {
			delete params.next_page;
			delete params.page;
		}

		//reset pagination count
		filter_pagination.current_page = '1';

		// effacer les valeur de params si la classe de la cat nest pas active
		$('.tax__item:not(.active)').each(function() {
			const $this = $(this);
			const tax = $this.data('tax');
			const id = $this.data('id');
			if (params.hasOwnProperty(tax) && params[tax].includes(id)) {
				params[tax].splice(params[tax].indexOf(id), 1);
			}
		});

		// ajouter les valeurs de la categorie si les elements on la categorie active
		$('.tax__item.active').each(function() {
			const $this = $(this);
			const tax = $this.data('tax');
			const id = $this.data('id');
			if (params.hasOwnProperty(tax) && !params[tax].includes(id)) {
				params[tax].push(id);
			} else {
				params[tax] = [id];
			}
		});
		console.log(params);
		ajax(params);
	});

	// Ajax pagination
	$('.filter__right').on('click', '.pagination', function(e) {
		params.action = 'filter_pagination';
		params.page = filter_pagination.current_page;
		if ($(this).hasClass('next')) {
			params.next_page = 'next';
		} else {
			params.next_page = 'prev';
		}
		console.log(params);

		ajax(params);
	});
});

// function ajax
function ajax($params) {
	$.ajax({
		url: filter.ajax_url,
		data: $params,
		type: 'POST',
		//dataType: 'JSON',
		beforeSend: function() {
			var placeholder =
				'<div class="placeholder"></div><div class="placeholder"></div><div class="placeholder"></div><div class="placeholder"></div><div class="placeholder"></div><div class="placeholder"></div><div class="placeholder"></div><div class="placeholder"></div>';
			$('.filter__right').addClass('loading');
			$('.filter__right .filter__post, .filter__right .filter__map').html('');
			$(placeholder).appendTo('.filter__post');
		},
		success: function(data) {
			if ($params.next_page == 'next') {
				filter_pagination.current_page++;
			} else if ($params.next_page == 'prev') {
				filter_pagination.current_page--;
			}
			if (data) {
				$('.filter__right').removeClass('loading');
				$('.filter__right').html('');
				$('.loading').addClass('hidden');
				$('.filter__right').html(data);
				new LazyLoad({
					elements_selector: '.lazy'
				});
				map = new_map($('.filter__map'));
			} else {
				$('.filter__right').html('No posts found.');
			}
		},
		complete: function() {
			catReplace();
		}
	});
}
